const ro = {
  common: {
    // Indicador global de datos simulados (MockDataBadge). Ver docs/contexto/decisiones.md D-8.
    mockData: 'Date de demonstrație',
    mockDataHint: 'Serviciul de Recunoaștere nu este încă implementat: acest ecran este alimentat cu date simulate din interiorul aplicației.',
    loading: 'Se încarcă...',
    error: 'Eroare',
    documentNotAvailable: 'Acest document nu este disponibil momentan. Poate depinde de limba ta sau de unitatea ta; contactează administratorul dacă problema persistă.',
    sessionExpiredMessage: 'Sesiunea ta a expirat. Salvează ce poți și conectează-te din nou.',
    reload: 'Conectează-te din nou',
    save: 'Salvează',
    cancel: 'Anulează',
    delete: 'Șterge',
    edit: 'Editează',
    moveUp: 'Mută sus',
    moveDown: 'Mută jos',
    close: 'Închide',
    download: 'Descarcă',
    confirm: 'Confirmă',
    search: 'Căutare',
    filter: 'Filtrează',
    export: 'Exportă',
    yes: 'Da',
    no: 'Nu',
    back: 'Înapoi',
    next: 'Următorul',
    submit: 'Trimite',
    darkMode: 'Mod întunecat',
    lightMode: 'Mod luminos',
    languageMenuTitle: 'Schimbă limba',
    logout: 'Deconectare',
    pagerShow: 'Afișează',
    pagerPerPage: 'pe pagină',
    pagerOf: 'din',
    viewCards: 'Vizualizare card-uri',
    viewList: 'Vizualizare listă',
    collapse: 'Restrânge',
    expand: 'Extinde',
    previousPage: 'Pagina anterioară',
    nextPage: 'Pagina următoare',
    retry: 'Reîncearcă',
    errorBoundaryTitle: 'Ceva nu a funcționat corect',
    errorGeneric: 'A apărut o eroare neașteptată. Te rugăm să încerci din nou.',
    expandModal: 'Extinde în fereastră modală',
    resetToGlobal: 'Revino la global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Acasă',
    growth: 'Creștere',
    admin: 'Administrare',
    executive: 'Executiv',
    analytics: 'Analiză',
    switchDemoProfile: 'Schimbă profilul demo',
    mobileNav: 'Navigare principală',
    fundamentals: 'Fundamentale',
    usersAdmin: 'Administratori',
    recognitionSection: 'Recunoașteri',
    language: 'Limbă',
    collapseMenu: 'Restrânge meniul',
    expandMenu: 'Extinde meniul',
  },
  roles: {
    employee: 'Angajat',
    adminOU: 'Administrator UO Pulso',
    adminGlobal: 'Administrator General',
    adminPulso: 'Administrator Pulso',
    adminBrillamos: 'Administrator Brillamos',
    adminOUBrillamos: 'Administrator UO Brillamos',
  },
  access: {
    noModulesTitle: 'Fără acces la niciun modul',
    noModulesDesc: 'Contul tău nu are activat nici Pulso, nici Recunoaștere. Solicită accesul administratorului organizației tale.',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Sondaje în așteptare',
    pending: 'În așteptare',
    completed: 'Finalizat',
    expired: 'Expirat',
    submit: 'Trimite evaluarea',
    skip: 'Omite',
    noObs: 'Nicio observație',
    meeting: 'Întâlnire',
    duration: 'Durată',
    participants: 'Participanți',
    simulateMeeting: 'Simulează sfârșitul întâlnirii',
    thankYou: 'Îți mulțumim pentru evaluare!',
    evaluating: 'Se evaluează',
    of: 'din',
    question: 'Întrebare',
    selectResponse: 'Selectează un răspuns',
    nps: {
      question: 'Cât de probabil este să recomanzi colaborarea cu această persoană?',
      detractor: 'Detractor',
      passive: 'Pasiv',
      promoter: 'Promotor',
    },
    evaluateNow: 'Evaluează acum',
    postpone: 'Mai târziu',
    expires: 'Expiră',
    noSurveysPending: 'Niciun sondaj în așteptare! Felicitări.',
    weekCompleted: 'săpt.',
    likert: {
      always: 'Întotdeauna',
      usually: 'De obicei',
      sometimes: 'Uneori',
      rarely: 'Rareori',
      notObservable: 'Neobservabil',
    },
    questions: {
      listenedActivelyText: 'A ascultat această persoană activ și a arătat un interes autentic?',
      sharedKnowledgeText: 'A împărtășit cunoștințe sau experiențe relevante în timpul întâlnirii?',
    },
    completeSubtitle: 'Feedback-ul tău ajută la consolidarea culturii echipei.',
    backToHome: 'Înapoi la pagina principală',
    greetingMorning: 'Bună dimineața',
    greetingAfternoon: 'Bună ziua',
    greetingEvening: 'Bună seara',
    pendingCountPre: 'Ai',
    pendingCountSingular: 'sondaj în așteptare',
    pendingCountPlural: 'sondaje în așteptare',
    allDoneTitle: 'Totul este la zi!',
    allDoneSubtitle: 'Nu ai sondaje în așteptare. Vor apărea aici după următoarea ta întâlnire.',
    omit: 'Omite',
    omitSurvey: 'Omite sondajul',
    submitSuccess: 'Răspunsuri trimise',
    submitError: 'Eroare la trimitere — te rugăm să încerci din nou',
    omitSuccess: 'Sondaj omis',
    omitError: 'Eroare la omitere — te rugăm să încerci din nou',
    unavailableError: 'Acest sondaj nu mai este disponibil',
    kpi: {
      answered: 'Răspuns',
      omitted: 'Omis',
      streak: 'Serie',
      participation: 'Participare',
    },
    growth: {
      title: 'Creșterea ta te așteaptă',
      message: 'Analizează-ți rezultatele, tendințele și zonele de dezvoltare în panoul tău de creștere.',
      cta: 'Vezi creșterea mea',
    },
    recognition: {
      title: 'Strălucim Împreună',
      message: 'Recunoaște-ți colegii și sărbătorește realizările lor în Programul de Recunoaștere.',
      cta: 'Mergi la Recunoaștere',
    },
    tips: {
      title: 'Sfaturi pentru tine',
      based: 'Bazat pe scorul tău mediu',
      empty: 'Completează mai multe sondaje pentru a vedea sfaturi personalizate',
      reconocer: 'De recunoscut',
      crecer: 'De dezvoltat',
      tipOfDay: 'Sfatul zilei',
    },
  },
  safe: {
    title: 'Creșterea Mea',
    subtitle: 'Dezvoltarea ta culturală la Sigma',
    sectionName: 'Feedback-ul meu',
    surveysAnswered: 'Sondaje completate',
    score: 'Scorul Tău',
    evolution: 'Evoluția ta',
    evolutionSub: 'Călătoria ta personală — doar tu, fără comparații',
    radarTitle: 'Profilul tău pe Fundamentale',
    radarSub: 'Tu astăzi vs tu acum 3 luni',
    fundamentals: 'Fundamentale',
    fundamentalsChart: 'Feedback-ul tău pe Fundamentale',
    fundamentalsChartSub: 'Unde te afli la fiecare — apasă pe orice bară pentru detalii',
    behaviors: 'Comportamente',
    kudos: 'Kudos',
    kudosTitle: 'De Recunoscut — ce aduci tu cel mai mult',
    kudosSub: 'Ce observă colegii tăi cel mai mult la tine luna aceasta',
    actions: 'Plan de acțiune',
    omissions: 'Omisiuni',
    period: 'Perioadă',
    received: 'Primite',
    sent: 'Trimise',
    areaAverage: 'Media zonei',
    today: 'Astăzi (ultimele {{days}} de zile)',
    threeMonthsAgo: 'Acum 3 luni (fereastră de {{days}} de zile)',
    detail: 'Detaliu',
    profileTitle: 'Profilul tău cultural în cuvinte',
    profileSub: 'Comportamente, nu cifre',
    basedOn: 'Bazat pe {{count}} feedback-uri anonime',
    level0: 'La început',
    level1: 'În dezvoltare',
    level2: 'Consecvent',
    level3: 'Model de urmat',
    level0desc: 'Așteaptă ca alții să rezolve problemele sau să înlăture obstacolele.',
    level1desc: 'Încearcă să abordeze obstacolele, dar renunță repede sau escaladează prematur.',
    level2desc: 'Ia inițiativa de a înlătura obstacolele și de a găsi soluții pentru a avansa.',
    level3desc: 'Îi inspiră pe ceilalți să ia inițiativa și creează un mediu în care depășirea blocajelor este o responsabilitate comună.',
    levelAbbr0: 'Început',
    levelAbbr1: 'În dezv.',
    levelAbbr2: 'Consecv.',
    levelAbbr3: 'Model',
    todayLabel: 'Astăzi',
    pointsInMonths: 'puncte în {{n}} luni',
    monthsWithFeedback: 'luni cu feedback',
    journeyLoading: 'Se încarcă evoluția ta…',
    journeyEmpty: 'Încă nu există suficient istoric pentru a desena evoluția ta. Ai nevoie de cel puțin două luni cu feedback.',
    journeyChartLabel: 'Evoluția mediei tale lună de lună',
    thisMonth: 'luna aceasta',
    headingToLevel: 'Pe drumul spre {{level}}',
    maxLevel: 'Nivel maxim!',
    narrativeStrength: 'Ceea ce aduci tu cel mai mult și merită recunoaștere este <strong>{{fund}}</strong> — te afli la nivelul <strong>{{level}}</strong>.',
    narrativeConsistency: 'De asemenea, arăți consecvență în {{others}}.',
    narrativeProgress: 'În ultimele 3 luni ai avansat — profilul tău arată creștere.',
    narrativeStable: 'Profilul tău a rămas stabil în ultimele 3 luni — asta arată consecvență.',
    narrativeVariation: 'Profilul tău a variat puțin în ultimele luni. Variațiile sunt normale și nu definesc cine ești.',
    narrativeNextLevel: 'Următorul tău nivel de creștere este în <strong>{{fund}}</strong>. Următorul pas este să atingi nivelul {{level}} — mai jos îți sugerăm o acțiune concretă.',
    act01: 'Recunoaștere — cum te văd ceilalți',
    act02: 'Progres — cum ai evoluat',
    act03: 'Direcție — următorul tău pas',
    reinforces: 'CONSOLIDEAZĂ',
    tryToday: 'Voi încerca asta azi',
    committed: 'Mă angajez astăzi!',
    defaultChallenge: 'Exersează astăzi un fundamental',
    defaultChallengeDesc: 'Alege o micro-acțiune și pune-o în practică la următoarea ta întâlnire.',
    clickDetail: 'Apasă pentru detalii',
    nextLevel: 'NIVELUL URMĂTOR',
    growthTitle: 'PENTRU A CONTINUA SĂ CREȘTI',
    growthSub: 'Recomandări bazate pe feedback-ul tău',
    feedbacks: 'feedback-uri',
    peers: 'colegi',
    givenTitle: 'Participarea mea la oferirea de feedback',
    givenSub: 'Feedback pe care l-ai oferit luna aceasta',
    footerPrivacy: 'Tot feedback-ul este anonim. Nimeni nu poate vedea cine ți l-a oferit. Această imagine îți aparține doar ție.',
    footerHeart: 'Ține minte: feedback-ul este un cadou. Aceste date reflectă momente din întâlniri, nu cine ești.',
    personSingular: 'persoană',
    personsPlural: 'persoane',
    trend: {
      up: 'Profilul tău arată creștere',
      down: 'Variație mică — este normal',
      stable: 'Profil stabil — asta înseamnă consecvență',
    },
    empty: {
      title: 'Descoperă Fundamentals',
      desc: 'Încă nu ai suficient feedback pentru a-ți afișa panoul. Între timp, explorează comportamentele pe care le măsurăm.',
      hint: 'Panoul tău se activează după ce ai răspuns la mai mult de 3 sondaje și ai primit cel puțin 3 evaluări de la colegi.',
      answeredLabel: 'Sondaje la care ai răspuns',
      receivedLabel: 'Evaluări pe care le-ai primit',
    },
    error: {
      title: 'Nu am putut încărca panoul tău',
      desc: 'A apărut o problemă la preluarea informațiilor tale. Încearcă din nou; dacă persistă, anunță echipa de suport.',
      retry: 'Încearcă din nou',
      retrying: 'Se reîncearcă…',
    },
    given: {
      loading: 'Se încarcă istoricul tău…',
      empty: 'Încă nu ai răspuns la niciun sondaj.',
      loadError: 'Nu am putut încărca istoricul sondajelor la care ai răspuns.',
      completed: 'Finalizat',
      peopleCount_one: '{{count}} persoană',
      peopleCount_other: '{{count}} persoane',
    },
    celebration: {
      default: 'Felul tău de a lucra lasă o urmă în cei din jur.',
      learner: 'Curiozitatea și deschiderea ta spre învățare îi inspiră pe cei cu care lucrezi.',
      player_owner: 'Îți asumi responsabilitatea fără să ți-o ceară nimeni, iar asta dă ritmul echipei.',
      psychological_safety: 'Felul în care asculți îi face pe ceilalți să spună ce gândesc.',
      collaborate_effectively: 'Când colaborezi tu, munca tuturor avansează mai repede.',
      quality_of_work: 'Grija ta pentru detalii ridică standardul a ceea ce livrează echipa.',
      make_others_successful: 'Ai grijă ca ceilalți să strălucească, iar echipa întreagă observă.',
      explore_experiment: 'Disponibilitatea ta de a încerca lucruri noi deschide drumuri pe care nu le văzuse nimeni.',
    },
    popup: {
      peersOpined: 'colegi au evaluat',
      evaluationsCount: '{{count}} evaluări',
      subbehaviors: 'Subcomportamente',
      dailyHabits: 'Obiceiuri zilnice',
      monthlyHistory: 'Evoluție lunară',
      distribution: 'Distribuția feedback-ului',
      behaviorScale: 'Scala comportamentului',
      you: 'Tu',
    },
  },
  admin: {
    title: 'Administrare',
    menu: {
      general: 'Administrator General',
      pulso: 'Pulso',
      brillamos: 'Brillamos',
    },
    roleAdminGeneral: 'Administrator General',
    roleAdminPulso: 'Administrator Pulso',
    roleAdminOUPulso: 'Administrator UO Pulso',
    roleAdminBrillamos: 'Administrator Brillamos',
    roleAdminOUBrillamos: 'Administrator UO Brillamos',
    roleEmployee: 'Angajat',
    greetingMorning: 'Bună dimineața',
    greetingAfternoon: 'Bună ziua',
    greetingEvening: 'Bună seara',
    surveys: 'Sondaje',
    templates: 'Șabloane',
    analyticsTab: 'Analiză',
    rulesTab: 'Reguli de afaceri',
    users: 'Utilizatori',
    notifications: 'Notificări',
    surveysTitle: 'Gestionarea sondajelor',
    searchSurvey: 'Caută sondaj...',
    trash: 'Coș de gunoi',
    newSurvey: 'Sondaj nou',
    fundamentalsTab: 'Fundamentale',
    customTab: 'Personalizat',
    colName: 'Nume',
    colTitle: 'Titlu',
    colDescription: 'Descriere',
    colQuestions: 'Întrebări',
    colStatus: 'Stare',
    colAudience: 'Audiență',
    sectionCrashed: "Această secțiune nu a putut fi afișată. Încearcă din nou sau alege alta.",
    colFrequency: 'Frecvență',
    freqDaily: 'Zilnic',
    freqWorkdays: 'Zile lucrătoare',
    freqWeekly: 'Săptămânal · {{day}}',
    freqCustom: '{{count}} zile/săptămână',
    freqNone: '—',
    colFeedback: 'Feedback',
    colPeriod: 'Perioadă',
    colActions: 'Acțiuni',
    colCreatedBy: 'Creat de',
    creatorUnknown: 'Necunoscut',
    colEmail: 'Email',
    colOU: 'UO',
    colUses: 'utilizări',
    statusActive: 'Activ',
    statusPaused: 'Întrerupt',
    statusInactive: 'Inactiv',
    statusPending: 'În așteptare',
    anonymous: 'Anonim',
    duplicate: 'Duplică',
    exportExcelTip: 'Exportă Excel',
    templatesTitle: 'Șabloane de sondaje',
    tipsTab: 'Sfaturi',
    actionsTab: 'Acțiuni',
    catalogTab: 'Cataloage',
    createTemplate: 'Creează șablon',
    typeFundamental: 'Fundamental',
    typeCustom: 'Personalizat',
    placeholderTips: 'Sfaturi — Modul de consiliere pentru angajați',
    placeholderActions: 'Acțiuni — Planuri de acțiune post-sondaj',
    placeholderCatalog: 'Catalog de fundamentale — Bibliotecă de comportamente evaluabile',
    tplSearchPlaceholder: 'Caută șablon…',
    tplFilterAll: 'Toate tipurile',
    tplNoResults: 'Niciun șablon nu corespunde acestui criteriu',
    tipsTitle: 'Sfaturi despre feedback',
    tipsSearchPlaceholder: 'Caută sfat…',
    tipsAllFundamentals: 'Toate fundamentalele',
    tipsAllTypes: 'Toate tipurile',
    tipTypeReconocer: 'De recunoscut',
    tipTypeCrecer: 'De dezvoltat',
    tipsNoResults: 'Niciun sfat nu corespunde acestui criteriu',
    surveysNoResults: 'Niciun sondaj nu corespunde acestui criteriu',
    surveysError: 'Eroare la încărcarea sondajelor. Te rugăm să încerci din nou mai târziu.',
    createTip: 'Creează sfat',
    actionsTitle: 'Acțiuni de creștere',
    actionsSearchPlaceholder: 'Caută acțiune…',
    actionsNoResults: 'Nicio acțiune nu corespunde acestui criteriu',
    createAction: 'Creează acțiune',
    catalogTitle: 'Catalog de fundamentale',
    catalogFundamentals: 'Fundamentale',
    catalogBehaviors: 'Comportamente',
    catalogAddFundamental: 'Adaugă fundamental',
    catalogAddBehavior: 'Adaugă obicei zilnic',
    catalogSearchFundamental: 'Caută fundamental…',
    catalogSearchBehavior: 'Caută obicei zilnic…',
    catalogNoBehaviors: 'Niciun obicei zilnic pentru acest fundamental',
    catalogSelectFundamental: 'Selectează un fundamental din listă',
    ousTab: 'UO-uri',
    ousTitle: 'Unități organizaționale',
    ousSubtitle: 'Gestionează UO-urile rădăcină pentru acest tenant',
    ousSearchPlaceholder: 'Caută UO…',
    ousNoResults: 'Nicio UO nu corespunde acestui criteriu',
    createOU: 'Creează UO',
    editOU: 'Editează UO',
    deleteOU: 'Șterge UO',
    deleteOUConfirm: 'Ștergi UO "{{name}}"? Această acțiune nu poate fi anulată.',
    ouDescription: 'Descriere',
    ouAdminUser: 'Administrator UO (ID utilizator AAD)',
    ouType: 'Tip',
    ouGdpr: 'RGPD',
    ouAzureGroupId: 'ID grup Azure AD',
    ouAzureGroupIdHint: 'Leagă această UO de grupul ei real din Azure AD pentru arborele ierarhic. Lasă gol dacă nu este încă asociat.',
    ouAzureGroupIdSelectPlaceholder: '— Selectează un grup rădăcină Azure AD —',
    ouAzureGroupIdLoading: 'Se încarcă grupurile Azure AD…',
    ouAzureGroupIdRootsError: 'Lista de grupuri Azure AD nu a putut fi încărcată. Poți introduce ID-ul manual.',
    ouAzureGroupIdCurrentUnknown: 'Grup asociat în prezent (nu este în listă)',
    ouAzureGroupIdManualToggle: 'Introdu ID-ul manual',
    ouAzureGroupIdListToggle: 'Alege din listă',
    ouActivate: 'Activează UO',
    ouDeactivate: 'Dezactivează UO',
    ouActivateCascadeTitle: 'Activează UO și unitățile subordonate',
    ouActivateCascadeConfirm: 'Activarea „{{name}}” va activa și toată descendența acesteia (unități subordonate afectate: {{units}}). Le poți dezactiva individual ulterior.',
    ouDeactivateCascadeTitle: 'Dezactivează UO și unitățile subordonate',
    ouDeactivateCascadeConfirm: 'Dezactivarea „{{name}}” va dezactiva și toată descendența acesteia (unități subordonate afectate: {{units}}).',
    ouActiveSaveError: 'Modificarea stării UO nu a putut fi salvată. Încearcă din nou.',
    ouExpand: 'Extinde',
    ouLockedHint: "Unitatea ta organizatorică: nu poate fi eliminată din arie.",
    ouCollapse: 'Restrânge',
    ouSelectPlaceholder: 'Selectează OU…',
    ouSearchPlaceholder: 'Caută OU…',
    ouSearchNoResults: 'Niciun rezultat.',
    ouInactiveHint: 'OU inactivă: nu poate fi aleasă ca arie nouă.',
    ouSelectAllInLevel: 'Selectează tot',
    ouBackToLevels: 'Înapoi la nivelul anterior',
    ouErrorName: 'Numele UO este obligatoriu',
    ouTimezone: 'Fus orar',
    ouTimezoneSelect: 'Selectează fusul orar',
    ouErrorTimezone: 'Fusul orar este obligatoriu',
    colFundamental: 'Fundamental',
    colCondition: 'Condiție',
    placeholderAnalytics: 'Panou unificat de analiză — Vezi vizualizarea Executivă pentru detalii complete',
    activeUsersLabel: 'Angajați activi',
    avgCulturalScore: 'Scor cultural mediu',
    participationRateLabel: 'Rata de participare',
    omissionRateLabel: 'Rata de omitere',
    thisMonth: 'luna aceasta',
    rulesTitle: 'Reguli de afaceri',
    restoreDefaults: 'Restabilește setările implicite',
    restoreDefaultsTitle: 'Restabilește configurația implicită',
    restoreDefaultsDesc: 'Toate valorile regulilor de afaceri vor fi resetate la configurația lor originală. Această acțiune nu poate fi anulată.',
    restoreDefaultsConfirm: 'Da, restabilește',
    rn001Title: 'Criterii de întâlnire',
    rn001Subtitle: 'Definește durata întâlnirii care declanșează un sondaj',
    rn002Title: 'Reguli de excludere',
    rn002Subtitle: 'Scenarii în care sondajele NU sunt declanșate',
    rn004Title: 'Limite pentru utilizatori',
    rn004Subtitle: 'Controlează numărul de sondaje pe care le primește fiecare persoană',
    rn005Title: 'Limită zilnică de sondaje',
    rn005Subtitle: 'Numărul maxim de sondaje pe care un utilizator le poate primi într-o zi',
    fieldMinSessionDuration: 'Durata minimă a sesiunii',
    fieldMaxSessionDuration: 'Durata maximă a sesiunii',
    fieldMinParticipants: 'Număr minim de participanți',
    fieldMaxParticipants: 'Număr maxim de participanți',
    fieldExclRecurring: 'Exclude întâlnirile recurente',
    fieldExclRecurringSub: 'Nu se aplică întâlnirilor săptămânale, dailies etc.',
    fieldExclWorkHours: 'Exclude în afara orelor de lucru',
    fieldExclWorkHoursSub: 'Se aplică doar în intervalul orar configurat per UO',
    fieldMaxSurveysWeek: 'Număr maxim de sondaje pe săptămână',
    fieldMaxParticipantsPerSurvey: 'Număr maxim de participanți de evaluat per sondaj',
    fieldMinInterval: 'Interval minim între sondaje',
    fieldMaxSurveysDay: 'Număr maxim de sondaje pe zi per utilizator',
    rn005Info: 'Dacă un utilizator a primit deja numărul maxim de sondaje pentru ziua respectivă, următoarele sunt amânate pentru următoarea zi lucrătoare, respectând ordinea de prioritate configurată.',
    suffixMinutes: 'minute',
    suffixUsers: 'utilizatori',
    suffixSurveysWeek: 'sondaje/săptămână',
    suffixPersons: 'persoane',
    suffixHours: 'ore',
    suffixSurveysDay: 'sondaje / zi',
    customizableByOU: 'Personalizabil per UO',
    cancelChanges: 'Anulează modificările',
    saveConfig: 'Salvează configurația',
    rulesConfig: 'Configurație',
    rulesStatus: 'Stare',
    rulesCustom: 'Personalizat',
    rulesSave: 'Salvează',
    rulesCancel: 'Anulează',
    rulesSchedule: 'Program',
    rulesInheritsGlobal: '↑ Moștenește global',
    rulesInherited: 'Moștenit',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personalizează',
    tplCatAll: 'Toate',
    tplCatGeneral: 'General',
    tplCatCustom: 'Personalizat',
    usersTitle: 'Gestionarea utilizatorilor',
    searchUser: 'Caută utilizator...',
    newUser: 'Utilizator nou',
    notificationsTitle: 'Setări de notificare',
    notifOmitirTitle: 'Notificare la omitere',
    notifyAfter: 'Notifică după',
    consecutiveOmissions: 'omiteri consecutive',
    notifyTo: 'Notifică:',
    notifyUser: 'Utilizator',
    notifyDirectManager: 'Manager direct',
    notifyAdminOU: 'Administrator UO',
    messageForUser: 'Mesaj pentru utilizator:',
    availableVarsOmitir: 'Variabile disponibile: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omiteri Europa (BU)',
    manualOnlyGDPR: 'Doar manual — RGPD',
    gdprWarning: 'Din cauza reglementărilor legale (RGPD), e-mailurile de omitere pentru Europa nu sunt niciodată trimise automat. Administratorul trebuie să le redacteze, să le revizuiască și să le trimită manual.',
    emailTemplateEmployee: 'Șablon de e-mail — angajat Europa:',
    reviewBeforeSending: 'Revizuiește și personalizează înainte de fiecare trimitere.',
    generalNotificationsTitle: 'Notificări generale',
    notifMessageLabel: 'Mesaj de notificare:',
    notifMessagePlaceholder: 'Scrie mesajul pe care vrei să îl trimiți angajaților...',
    notifAudienceLabel: 'Audiență:',
    notifAudienceGlobal: 'Global (excl. Europa)',
    sendNotification: 'Trimite notificarea',
    availableVarsGeneral: 'Variabile disponibile: {nombre}, {ou}, {fecha}',
    saveChanges: 'Salvează modificările',
    saveTemplates: 'Salvează șabloanele',
    analyticsComingSoon: 'Panou de analiză — în dezvoltare. Vezi vizualizarea Executivă pentru detalii complete.',
    colType: 'Tip',
    tplCategory: 'Categorie',
    tplQuestions: 'întrebări',
    tplUse: 'Utilizează',
    tplDeleteTitle: 'Șterge șablonul',
    tplDeleteDesc: 'Ștergi "{{name}}"? Această acțiune nu poate fi anulată.',
    tipDeleteTitle: 'Șterge sfatul',
    tipDeleteDesc: 'Ștergi "{{name}}"? Această acțiune nu poate fi anulată.',
    tipEditTitle: 'Editează sfatul',
    tipAddTitle: 'Adaugă sfat',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Selectează un fundamental…',
    tipFormDailyHabit: 'Obicei zilnic asociat',
    tipFormSelectDailyHabit: 'Selectează un obicei zilnic…',
    tipFormOperator: 'Operator',
    tipFormThreshold: 'Prag %',
    tipFormMax: 'Max %',
    tipFormType: 'Tip de sfat',
    tipFormName: 'Nume sfat',
    tipFormNamePlaceholder: 'Ex.: Învățare remarcabilă',
    tipFormText: 'Text sfat',
    tipFormTextPlaceholder: 'Mesajul pe care îl va vedea colaboratorul…',
    tipFormActivationRule: 'Condiție de rezultat',
    tipFormActive: 'Activ',
    tipFormPreview: 'Previzualizare',
    tipRangeMin: 'Limită minimă',
    tipRangeMax: 'Limită maximă',
    tipHintCondition: 'Scorul mediu al fundamentalului (0–100). Ex.: 0 până la 40 activează sfatul pentru rezultate slabe.',
    tipHintBehavior: 'Comportamentul specific căruia i se aplică acest sfat.',
    tipFieldObserved: 'Text observat',
    tipTagGreen: 'casetă verde deschis',
    tipTagDark: 'casetă întunecată',
    tipTagBlue: 'casetă Nivelul următor',
    tipHintObserved: 'Ce observă colegii cel mai mult. Afișat cu caractere cursive în panoul de realizări.',
    tipFieldGrowthSuggestion: 'Sugestie de dezvoltare',
    tipHintGrowthSuggestion: 'Sugestie concretă afișată alături de recunoaștere.',
    tipFieldLevelName: 'Nume nivel',
    tipLevelNamePlaceholder: 'Ex.: Impuls necesar, În construcție…',
    tipCrecerPairedPlaceholder: 'Ex.: Menționează consumatorul: La următoarea ta decizie, întreabă…',
    tipTranslations: 'Traduceri',
    tipAddLang: '+ Adaugă:',
    tipPreviewContext: 'Așa va apărea pe panoul colaboratorului:',
    tipSave: 'Salvează sfatul',
    tipSaveError: 'Pentru a salva, completează următoarele câmpuri:',
    colContent: 'Conținut',
    colActive: 'Activ',
    opGte: 'mai mare sau egal',
    opLte: 'mai mic sau egal',
    opGt: 'mai mare decât',
    opLt: 'mai mic decât',
    opBetween: 'Între (interval)',
    actionEditTitle: 'Editează acțiunea',
    actionNewTitle: 'Acțiune nouă',
    actionFormTitle: 'Titlul acțiunii',
    actionFormTitlePlaceholder: 'Ex.: Propune o acțiune concretă',
    actionFormDescription: 'Descriere completă',
    actionFormDescPlaceholder: 'Descrierea acțiunii…',
    actionActivationRule: 'Regulă de activare',
    actionActivationRuleHint: 'Scorul mediu al fundamentalului (1–4). Definește intervalul care declanșează această acțiune.',
    actionRuleMin: 'Prag minim',
    actionRuleMax: 'Prag maxim',
    actionRangeLabel: 'Interval',
    actionNextLevelText: 'Text "Nivelul următor"',
    actionNextLevelHint: 'Afișat în caseta albastră de pe card.',
    actionNextLevelPlaceholder: 'Ex.: Pentru a atinge nivelul următor, concentrează-te pe…',
    actionPreview: 'Previzualizare',
    actionPreviewEmpty: 'Completează formularul pentru a vedea previzualizarea',
    actionTranslations: 'Traduceri',
    actionTransComplete: 'Traducere completă',
    actionTransMissing: 'Traducere incompletă',
    actionPreviewContext: 'Așa va apărea în panoul colaboratorului:',
    actionFormDescHint: 'Afișat atunci când acțiunea este deschisă.',
    actionSave: 'Salvează acțiunea',
    actionSaveError: 'Pentru a salva, completează următoarele câmpuri:',
    actionDeleteTitle: 'Șterge acțiunea',
    actionDeleteDesc: 'Ștergi "{{name}}"? Aceasta nu poate fi anulată.',
    fundEditTitle: 'Editează fundamentalul',
    fundNewTitle: 'Fundamental nou',
    fundFormFullName: 'Nume complet',
    fundFormFullNamePlaceholder: 'Ex.: Mindset & Behavior - Learner',
    fundFormShortName: 'Nume scurt',
    fundFormShortNamePlaceholder: 'Ex.: Learner',
    fundFormDescription: 'Descriere',
    fundFormDescriptionPlaceholder: 'Descriere scurtă a acestui fundamental...',
    fundFormIcon: 'Pictogramă',
    fundFormColor: 'Culoare',
    fundFormUrl: 'URL de referință',
    fundFormMicrositeUrl: 'URL-ul microsite-ului',
    fundFormUrlPlaceholder: 'https://...',
    fundFormLanguage: 'Limbă',
    fundFormAllLangsRequired: 'Completează numele complet, numele scurt și descrierea în toate cele 7 limbi pentru a salva.',
    behEditTitle: 'Editează obiceiul zilnic',
    behNewTitle: 'Obicei zilnic nou',
    behFormName: 'Nume obicei zilnic',
    behFormNamePlaceholder: 'Ex.: Humility & Openness',
    behFormAllLangsRequired: 'Completează numele în toate cele 7 limbi pentru a salva.',
    behFormFundamental: 'Fundamental asociat',
    behFormIntro: 'Introducere / context de evaluare',
    behFormIntroPlaceholder: 'Ex.: În această întâlnire, această persoană…',
    behFormRoles: 'Roluri aplicabile',
    behFormRolesHint: 'Cui i se aplică acest obicei zilnic?',
    fundDeleteTitle: 'Șterge fundamentalul',
    fundDeleteDesc: 'Ștergi "{{name}}"? Aceasta nu poate fi anulată.',
    behDeleteTitle: 'Șterge obiceiul zilnic',
    behDeleteDesc: 'Ștergi "{{name}}"? Aceasta nu poate fi anulată.',
    imageUploadSelect: 'Încarcă imagine',
    imageUploadChange: 'Schimbă imaginea',
    imageUploadInvalidFormat: 'Format neacceptat. Folosește PNG, JPG, WEBP sau SVG.',
    imageUploadTooLarge: 'Fișierul depășește dimensiunea maximă permisă (2 MB).',
    catalogSaveError: 'Modificările catalogului nu au putut fi salvate. Încearcă din nou.',
    catalogImageUploadError: 'Imaginea nu a putut fi încărcată. Încearcă din nou.',
    fundFormImage: 'Imagine',
    attNewTitle: 'Atitudine și Comportament nou',
    attEditTitle: 'Editează Atitudine și Comportament',
    attFormName: 'Numele Atitudinii și Comportamentului',
    attFormNamePlaceholder: 'Ex. Colaborare activă',
    attFormDescription: 'Descrierea Atitudinii și Comportamentului',
    attFormDescriptionPlaceholder: 'Scurtă descriere a acestei atitudini și comportament...',
    attFormAllLangsRequired: 'Completează numele în toate cele 7 limbi pentru a salva.',
    attFormImage: 'Imagine',
    attDeleteTitle: 'Șterge Atitudine și Comportament',
    attDeleteDesc: 'Ștergi "{{name}}"? Daily Habits asociate vor fi de asemenea dezactivate.',
    catalogAttitudesLabel: 'atitudini și comportamente',
    catalogSelectAttitude: 'Selectează o Atitudine și Comportament din listă',
    catalogBackToFundamentals: 'Înapoi la Fundamentals',
    catalogBackToAttitudes: 'Înapoi la Atitudini și Comportamente',
    catalogGroupWithAttitudes: 'Grupează sub Atitudini și Comportamente',
    catalogNoFundamentals: 'Niciun fundamental',
    madurezEditTitle: 'Editează nivelurile de maturitate culturală',
    madurezFrameworkTitle: 'Maturitate culturală — Cadrul nivelurilor',
    nivelesAdopcionTitle: 'Etape de adopție a obiceiurilor zilnice — Cadrul nivelurilor',
    nivelesAdopcionEditTitle: 'Editează etapele de adopție a obiceiurilor zilnice',
    madurezLabelPlaceholder: 'Etichetă',
    audienceGlobal: 'Global (excl. Europa)',
    audienceMexico: 'Mexic',
    audienceLATAM: 'LATAM',
    audienceUSA: 'SUA',
    audienceFOSE: 'FOSE',
    rn000Title: 'Dezactivează aplicația per UO',
    rn000Subtitle: 'Dezactivează complet Sigma Pulse pentru una sau mai multe unități organizaționale. Angajații din acele UO-uri nu vor mai primi sondaje sau notificări.',
    rn000Warning: 'Când o UO este dezactivată, toți angajații ei încetează imediat să primească sondaje. Datele istorice sunt păstrate.',
    rn003Title: 'Program de lucru per UO',
    rn003Subtitle: 'Orele în care se aplică sondajele (ora locală)',
    rn003GlobalDefault: 'Ore implicite globale',
    rn003GlobalNote: 'Se aplică tuturor UO-urilor care nu au ore personalizate configurate.',
    rn003TimeConnector: 'până la',
    ouActive: 'Activă',
    ouDisabled: 'Dezactivată',
    rn002KwLabel: 'Exclude doar dacă numele conține:',
    rn002KwHint: '(gol = toate cele recurente)',
    rn002KwPlaceholder: 'Adaugă cuvânt cheie...',
    usersAdminTitle: 'Gestionarea administratorilor',
    addAdmin: 'Adaugă administrator',
    editAdmin: 'Editează administratorul',
    newAdmin: 'Administrator nou',
    adminEmail: 'Adresă de e-mail',
    adminUser: 'Utilizator',
    userSearchPlaceholder: 'Căutați după nume sau e-mail…',
    userSearchNoResults: 'Niciun utilizator găsit',
    userSearchError: 'Eroare la căutarea utilizatorilor',
    adminRole: 'Rol',
    adminRolePlaceholder: 'Selectează un rol...',
    adminOU: 'Unitate operațională (UO)',
    adminOUPlaceholder: 'Selectează o UO...',
    adminOUAll: 'Toate (acces complet la UO)',
    adminBU: 'Unitate de afaceri (BU) — opțional',
    adminBUPlaceholder: 'Întreaga UO (fără restricție)',
    adminBUHint: 'Dacă nu este selectată nicio BU, administratorul gestionează întreaga UO.',
    colUser: 'Utilizator',
    colAlcance: 'Domeniu',
    colPermisos: 'Permisiuni',
    colEstado: 'Stare',
    permGlobalTitle: 'Administratorii UO/BU pot crea sondaje',
    permGlobalDesc: 'Când este activă, toți administratorii UO/BU pot crea și trimite sondaje (sub rezerva aprobării Administratorului General sau a Administratorului Pulso).',
    permEnabled: 'Activat',
    permDisabled: 'Dezactivat',
    permCreateSurveys: 'Creează sondaje',
    permViewAnalytics: 'Vizualizează analiza',
    permManageUsers: 'Gestionează utilizatorii',
    permApproveSurveys: 'Aprobă sondaje',
    permCatalogFund: 'Catalog Fundamentals',
    permCatalogOus: 'Catalog OU-uri',
    // 2026-08-08 — reorganizarea meniului de Administrare
    administratorsTab: 'Gestionarea administratorilor',
    catalogFundTab: 'Catalog Fundamentals',
    catalogOusTab: 'Catalog OU-uri',
    rolesPulsoTab: 'Configurează rolurile și permisiunile',
    rolesPulsoTitle: 'Configurează rolurile și permisiunile',
    rolesPulsoAllScopes: 'Toate',
    rolesPulsoAlreadyNote: 'Această persoană este deja administrator Pulso — editează datele mai jos.',
    rolesPulsoCannotEditGlobal: 'Această persoană are deja rolul Admin General. Acel rol nu se gestionează de aici.',
    administratorsTitle: 'Gestionarea administratorilor',
    administratorsDesc: 'Adăugați sau eliminați administratori globali ai sistemului.',
    addGlobalAdmin: 'Adaugă administrator',
    newGlobalAdmin: 'Administrator global nou',
    adminGlobalRemoveTitle: 'Eliminați administratorul global',
    adminGlobalRemoveDesc: 'Eliminați „{{name}}" ca administrator global? Contul rămâne colaborator standard.',
    userDeleteTitle: 'Elimină rolul de administrator',
    userDeleteDesc: 'Elimini rolul de administrator pentru "{{name}}"? Contul rămâne activ ca angajat standard, fără permisiuni de administrare.',
    userCreated: 'Utilizator creat cu succes.',
    userSaveError: 'Modificările nu au putut fi salvate. Încearcă din nou.',
    userSaveForbidden: 'Nu ai permisiunea de a modifica acest administrator. Doar un Admin General poate.',
    userCreateErrorNotInAd: 'Utilizatorul nu a putut fi creat: e-mailul nu există în Azure AD.',
    userDeleteError: 'Rolul de administrator nu a putut fi eliminat. Încearcă din nou.',
    noUsersFound: 'Niciun rezultat găsit',
    adminCount: 'administratori',
    filterEmailPlaceholder: 'Căutare după e-mail...',
    filterRoleLabel: 'Filtrare după rol',
    filterRoleAll: 'Toate rolurile',
    filterClear: 'Șterge filtrele',
    rolesMultiHint: 'Poți selecta mai multe roluri ținând apăsată tasta Ctrl (Cmd pe Mac).',
    modulesTitle: 'Module',
    modulesHint: 'Controlează accesul la modulele produsului, indiferent de rolul atribuit.',
    modulePulso: 'Pulso',
    moduleBrillamos: 'Recunoaștere',
    permAllGranted: 'Toate acordate',
    userNotManageable: 'Nu poți gestiona acest utilizator',
    messageForManager: 'Mesaj pentru manager:',
    emailTemplateManager: 'Șablon de e-mail — manager Europa:',
    notifOUPersonalization: 'Personalizare per UO',
    addOUPersonalization: 'Adaugă personalizare',
    europaNoAutoSend: 'Aceste e-mailuri nu sunt trimise automat. Trebuie trimise manual și aliniate cu responsabilul cu confidențialitatea din Europa.',
    europaActivateTitle: 'Activezi notificările pentru Europa?',
    europaActivateDesc: 'Notificările de omitere pentru Europa sunt supuse unor reglementări RGPD stricte. Prin activarea acestei secțiuni confirmi că ai autorizarea responsabilului cu confidențialitatea din UO Europa și că e-mailurile vor fi trimise manual, cu revizuire prealabilă.',
    europaActivateConfirm: 'Da, activez responsabil',
    includeEuropa: 'Include Europa (BU)',
    includeEuropaHint: 'necesită revizuire RGPD înainte de trimitere',
    europaSectionDisabled: 'Secțiune dezactivată — activează comutatorul pentru a configura',
    ouPersonalizedSingular: 'UO personalizată',
    ouPersonalizedPlural: 'UO-uri personalizate',
    notifCustomUserMsgPlaceholder: 'Mesaj personalizat pentru utilizator…',
    notifCustomMgrMsgPlaceholder: 'Mesaj personalizat pentru manager…',
    kwRemove: 'Elimină',
    kwAdd: 'Adaugă',
    permissions: 'Permisiuni',
    rules: 'Reguli de afaceri',
    catalog: 'Catalog',
    createUser: 'Creează utilizator',
    editUser: 'Editează utilizatorul',
    deleteUser: 'Șterge utilizatorul',
    roles: 'Rol',
    organizationalUnit: 'Unitate organizațională',
    minDuration: 'Durată min. (min)',
    maxDuration: 'Durată max. (min)',
    minParticipants: 'Participanți min.',
    maxPerDay: 'Evaluări max. pe zi',
    maxPerWeek: 'Evaluări max. pe săptămână',
    omissionThreshold: 'Prag de omitere',
    columns: 'Coloane',
    colPickerTitle: 'Coloane vizibile',
    colPickerReset: 'Resetează',
    pagerRowsPerPage: 'Rânduri pe pagină',
    pagerOf: 'din',
    confirmMoveToTrash: 'Muți în coșul de gunoi?',
    confirmMoveToTrashMsg: 'Sondajul va fi mutat în coșul de gunoi și șters definitiv după 30 de zile. Îl poți restaura înainte de acest termen.',
    confirmMoveBtn: 'Mută în coșul de gunoi',
    confirmDeleteForeverTitle: 'Ștergi definitiv?',
    confirmDeleteForeverMsg: 'Această acțiune este ireversibilă. Sondajul și toate datele sale vor fi șterse definitiv.',
    confirmDeleteForeverBtn: 'Șterge definitiv',
    trashTitle: 'Coșul de gunoi al sondajelor',
    trashSubtitle: 'Sondajele sunt șterse definitiv după 30 de zile',
    trashEmpty: 'Coșul de gunoi este gol',
    trashRestore: 'Restaurează',
    trashDaysLeft: 'zile rămase',
    colSurvey: 'Sondaj',
    trashResponses: 'răsp.',
    trashTimeLeft: 'Timp rămas',
    trashDeletedBy: 'Șters de',
    trashDeletedAt: 'Data ștergerii',
    trashDays: 'zile',
    trashExpiresTODAY: 'Expiră azi',
    filterAll: 'Toate',
    filterSearchName: 'Caută nume…',
    filterSearchCreator: 'Caută creator…',
    filterFrom: 'De la',
    filterTo: 'Până la',
    filterClearDates: 'Șterge datele',
    pauseSurvey: 'Pune pauză',
    activateSurvey: 'Activează',
    builderNewTitle: 'Sondaj nou',
    builderEditTitle: 'Editează sondajul',
    builderNewTemplateTitle: 'Șablon nou',
    builderEditTemplateTitle: 'Editează șablonul',
    builderBackToSurveys: 'Înapoi la sondaje',
    builderSaveDraft: 'Salvează ciorna',
    builderPublish: 'Publică sondajul',
    builderStep1: 'Informații de bază',
    builderStep2: 'Audiență și frecvență',
    builderStep3: 'Întrebări',
    builderStep4: 'Revizuire',
    builderPreview: 'Previzualizare',
    builderName: 'Numele sondajului',
    builderNamePlaceholder: 'Ex.: Evaluare post-întâlnire T2',
    builderDescription: 'Descriere',
    builderDescriptionPlaceholder: 'Descrie scopul acestui sondaj…',
    builderApproach: 'Abordare',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Colectiv',
    builderAnonymous: 'Evaluare anonimă',
    builderAnonymousSub: 'Persoanele evaluate nu vor ști cine le-a evaluat',
    dayMon: 'Luni', dayTue: 'Marți', dayWed: 'Miercuri', dayThu: 'Joi',
    dayFri: 'Vineri', daySat: 'Sâmbătă', daySun: 'Duminică',
    dayMonShort: 'Lu', dayTueShort: 'Ma', dayWedShort: 'Mi', dayThuShort: 'Jo',
    dayFriShort: 'Vi', daySatShort: 'Sâ', daySunShort: 'Du',
    dayLetterMon: 'L', dayLetterTue: 'M', dayLetterWed: 'M', dayLetterThu: 'J',
    dayLetterFri: 'V', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'Sondajul va fi activ toată săptămâna',
    activeDaysPrefix: 'Sondajul va fi activ în:',
    activeDaysNone: 'Nicio zi selectată',
    workdays: 'Zile lucrătoare',
    builderExitTitle: 'Ieși din editor?',
    builderExitDesc: 'Modificările nesalvate se vor pierde dacă pleci acum.',
    builderExitCancel: 'Continuă editarea',
    builderExitConfirm: 'Da, ieși',
    builderValidationTitle: 'Câmpuri obligatorii',
    builderValidationDesc: 'Te rugăm să completezi următoarele câmpuri înainte de a continua:',
    builderValidationClose: 'Am înțeles',
    builderValidationName: 'Identificator intern',
    builderValidationSurveyType: 'Tipul sondajului',
    builderValidationStartDate: 'Data de început',
    builderValidationEndDate: 'Data de sfârșit',
    builderValidationDateRange: 'Data de sfârșit nu poate fi anterioară datei de început',
    builderValidationActiveDays: 'Cel puțin o zi activă',
    builderValidationStartDatePast: 'Data de început a trecut deja; sondajul nu ar fi publicat niciodată',
    builderValidationEndDatePast: 'Data de sfârșit a trecut deja; sondajul nu ar fi publicat niciodată',
    builderValidationMeetingId: 'Introdu ID-ul întâlnirii',
    builderValidationPeople: 'Selectează cel puțin o persoană',
    builderValidationOU: 'Selectează cel puțin o UO',
    builderValidationNoQuestions: 'Trebuie să adaugi cel puțin o întrebare pentru a continua. Sondajele nu pot fi create fără întrebări.',
    builderValidationMinParticipants: 'Numărul minim de participanți trebuie să fie cel puțin 1',
    builderValidationMaxParticipants: 'Numărul maxim de participanți trebuie să fie cel puțin 1',
    builderValidationParticipantsRange: 'Numărul minim de participanți nu poate fi mai mare decât maximul',
    builderValidationTranslations: 'Traduceri incomplete',
    // Builder new keys
    builderCloseEditor: 'Închide editorul',
    builderPrevious: 'Anterior',
    builderNext: 'Următorul',
    builderSaveTemplate: 'Salvează ca șablon',
    builderInternalId: 'Identificator intern',
    builderInternalIdHint: 'Vizibil doar pentru administratori — angajații nu văd acest nume atunci când răspund',
    builderSurveyTypeStar: 'Tipul sondajului',
    builderTypeGeneral: 'General',
    builderTypeGeneralDesc: 'Guvernat de regulile de afaceri. Declanșat automat după întâlniri.',
    builderTypePersonalized: 'Personalizat',
    builderTypePersonalizedDesc: 'Asociat unei sesiuni Teams specifice prin ID-ul întâlnirii.',
    builderPeriod: 'Perioada sondajului',
    builderStartLabel: 'Început',
    builderEndLabel: 'Sfârșit',
    builderPeriodHint: 'Sondajul se va activa la data de început și se va dezactiva automat la sfârșit',
    builderActiveDaysLabel: 'Zile active',
    builderActiveDaysLockedHint: 'Ziua este stabilită automat deoarece intervalul de date este de o singură zi',
    builderCustomTag: 'Personalizat',
    builderAudienceSectionTitle: 'Audiență',
    builderWhoApplies: 'Cui i se aplică acest sondaj?',
    builderSelectOneOrMoreOUs: 'Selectează una sau mai multe UO-uri',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Toate UO-urile și BU-urile',
    builderExcludesEurope: 'exclude Europa',
    builderGlobalAdminOUAccess: 'Administrator Global — ai acces la toate UO-urile din sistem.',
    builderLegalRegulation: 'Reglementare legală — întotdeauna un câmp separat',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'RGPD — Reglementare legală',
    builderEuropeExcludedNote: 'Europa nu este niciodată inclusă în campanii Globale sau multi-UO din motive de conformitate legală.',
    builderEuropaAuthNote: 'Nu uita să obții autorizarea UO Europa înainte de a trimite sondaje către această regiune.',
    builderAudienceCustomTitle: 'Destinatari',
    builderAudienceCustomSubtitle: 'Definește cine va primi acest sondaj personalizat.',
    builderRecipientsLabel: 'Destinatari',
    builderByMeetingId: 'După ID-ul întâlnirii',
    builderByPeople: 'Persoane specifice',
    builderByOU: 'După organigramă (UO)',
    audienceTypeMeeting: 'Întâlnire',
    audienceTypePeople: 'Persoane',
    audienceTypeOU: 'UO',
    builderMeetingIdHint: 'Se va aplica tuturor participanților la acea sesiune Teams',
    builderSelectPeople: 'Selectează persoane din listă',
    builderAllOUs: 'Toate UO-urile',
    builderAllAvailableAdded: 'Toate persoanele disponibile au fost deja adăugate',
    builderSearchPeoplePlaceholder: 'Caută o persoană după nume…',
    builderLoadingPeople: 'Se încarcă persoanele…',
    builderErrorLoadingPeople: 'Lista de persoane nu a putut fi încărcată. Încearcă din nou.',
    builderPersonSelected: 'persoană selectată',
    builderPeopleSelected: 'persoane selectate',
    builderSelectOU: 'Selectează o UO...',
    builderSelectOUForTeam: 'Selectează o UO pentru a-i vedea membrii',
    builderQuestionsTitle: 'Întrebări',
    builderEuropaQuestionsNote: 'Mod Europa: sondaj deschis, nelegat de Fundamentale. Doar întrebări despre întâlnire.',
    builderQuestionsApplyToAll: 'Fiecare întrebare se aplică fiecărui participant la întâlnire.',
    builderFilterAll: 'Toate',
    builderNoQuestions: 'Încă nu există întrebări',
    builderNoQuestionsHint: 'Apasă pe "+ Adaugă întrebare" pentru a începe',
    builderNoQuestionsOfType: 'Nicio întrebare de acest tip',
    builderAddQuestion: '+ Adaugă întrebare',
    builderQuestionLabel: 'Întrebare',
    builderDeleteQuestion: 'Șterge',
    builderApproachLabel: 'Abordare',
    builderIndividualSub: 'Evaluează fiecare participant',
    builderCollectiveSub: 'Pentru sesiune în ansamblu',
    builderPresentationMode: 'Mod de prezentare',
    builderMatrix: 'Matrice generală',
    builderMatrixSub: 'Întrebare despre întâlnire sau subiect general',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'Un card per persoană',
    builderTypeLabel: 'Tip',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Selectează un Fundamental...',
    builderDailyHabitLabel: 'Obicei zilnic',
    builderSelectDailyHabit: 'Selectează un obicei zilnic...',
    builderQuestionText: 'Textul întrebării',
    builderQuestionTextPlaceholder: 'Scrie întrebarea aici',
    builderIconLabel: 'Pictogramă',
    builderOptional: '(opțional)',
    builderChangeIcon: 'Schimbă',
    builderSelectIconBtn: 'Selectează pictograma',
    builderOptionsLabel: 'Opțiuni (max. 4 + "Neobservabil")',
    builderNoObservable: 'Neobservabil',
    builderRemoveNoObs: 'Elimină Neobservabil',
    builderAddNoObs: 'Adaugă "Neobservabil"',
    builderAddOption: 'Adaugă opțiune',
    builderMaxOptions: 'S-a atins maximul de 4 opțiuni',
    builderNPSInfo: 'NPS: scală de la 0 la 10. Întrebare deschisă, nealocată participanților.',
    builderOpenInfo: 'Spațiu deschis pentru ca evaluatorul să își scrie răspunsul.',
    builderCampaignWeight: 'Greutatea campaniei',
    builderAdminGlobalOnly: 'Doar Administrator General',
    builderCampaignWeightSub: 'Greutate mai mare = prioritate mai mare atunci când sunt active mai multe sondaje. Doar Administratorul General o poate modifica.',
    builderWeightBase: 'Greutate de bază (1–10)',
    builderWeightVeryLow: 'Foarte mică',
    builderWeightLow: 'Mică',
    builderWeightMedium: 'Medie',
    builderWeightHigh: 'Mare',
    builderWeightVeryHigh: 'Foarte mare',
    builderBoostUrgent: 'Impuls urgent',
    builderBoostUrgentSub: 'Ridică temporar acest sondaj deasupra tuturor celorlalte',
    builderBoostDays: 'zile',
    builderBoostActiveDays: 'zi',
    builderBoostActiveMsg: 'Impuls activ — acest sondaj va avea prioritate maximă timp de',
    builderNoBoostMsg: 'Niciun impuls activ — prioritate bazată pe greutatea de bază',
    builderParticipantsTitle: 'Participanți de evaluat',
    builderParticipantsSub: 'Definește câte persoane sunt evaluate per sondaj. Minim pentru anonimat și maxim pentru a evita supraîncărcarea.',
    builderMinParticipantsLabel: 'Număr minim de participanți',
    builderMinParticipantsHint: 'Min. pentru a asigura anonimatul',
    builderMaxParticipantsLabel: 'Număr maxim de participanți',
    builderMaxParticipantsHint: 'Max. persoane de evaluat per sondaj',
    builderPrivacyTitle: 'Confidențialitate și anonimat',
    builderPrivacySub: 'Definește dacă feedback-ul va fi asociat identității respondentului.',
    builderEnableAnonymity: 'Activează anonimatul',
    builderAnonymityDesc: 'Feedback-ul nu va include numele utilizatorului — doar răspunsul și ora',
    builderTranslationsTitle: 'Traduceri',
    builderTranslationsEuropeSub: 'Audiență Europa — toate cele 6 limbi sunt obligatorii. Folosește comutatorul pentru a activa sau dezactiva o limbă.',
    builderTranslationsSub: 'Traducerea în engleză este obligatorie ca minim. Folosește comutatorul pentru a activa limbi suplimentare.',
    builderAutoTranslateNote: 'Traducerile sunt generate automat cu Azure Translator. Revizuiește și ajustează fiecare câmp după cum este necesar.',
    builderLangNotApplicable: 'Nu se aplică',
    builderLangComplete: 'Finalizat',
    builderLangPending: 'În așteptare',
    builderLangRequired: 'Obligatoriu',
    builderLangOptional: 'Opțional',
    builderAutoTranslateBtn: 'Traducere automată',
    builderAutoTranslating: 'Se traduce…',
    builderAutoTranslateError: 'Traducerea automată a eșuat. Încearcă din nou.',
    sessionExpiredError: 'Sesiunea ta a expirat. Reîncarcă pagina și autentifică-te din nou.',
    builderSourceLangLabel: 'Limba sursă',
    builderSourceLangHint: 'Limba în care redactezi această întrebare. Celelalte limbi vor fi cerute ca traducere în secțiunea Traduceri.',
    builderLangApplies: 'Se aplică',
    builderLangDoesNotApply: 'Nu se aplică',
    builderTrlName: 'Nume:',
    builderTrlDesc: 'Descriere:',
    builderTrlEmpty: 'gol',
    builderLangDisabled: 'Această limbă este dezactivată pentru acest sondaj.',
    builderReviewTitle: 'Revizuiește și publică',
    builderReviewTemplateTitle: 'Revizuiește șablonul',
    builderEuropaPublishNote: 'Mod Europa: campanie independentă din cauza RGPD. Nu uita să obții autorizarea UO Europa.',
    builderPublishIdLabel: 'Identificator',
    builderPublishInternal: '(intern)',
    builderPublishTypeLabel: 'Tip',
    builderPublishAudienceLabel: 'Audiență',
    builderPublishQuestionsLabel: 'Întrebări',
    builderPublishActiveDaysLabel: 'Zile active',
    builderPublishExpirationLabel: 'Expirare',
    builderPublishAnonymityLabel: 'Anonimat',
    builderPublishAnonymousVal: 'Anonim',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Completează înainte de publicare:',
    builderCompleteBeforeSave: 'Completează înainte de salvare:',
    builderReadyToPublish: 'Totul este pregătit. Apasă pe Publică sondajul pentru a-l activa.',
    builderReadyToSaveTemplate: 'Totul este pregătit. Apasă pe Salvează șablonul pentru a-l salva.',
    builderIconCatalogTitle: 'Catalog de pictograme',
    builderSystemIcons: 'Pictograme de sistem',
    builderNoIcon: 'Fără pictogramă',
    builderMyCatalog: 'Catalogul meu',
    builderDeleteFromCatalog: 'Șterge din catalog',
    builderCatalogEmpty: 'Catalogul tău este gol — încarcă o pictogramă și salveaz-o aici',
    builderUploadIcon: 'Încarcă pictogramă nouă',
    builderIconNamePlaceholder: 'Numele pictogramei (ex.: Inovație)',
    builderSelectFile: 'Selectează fișierul',
    builderInvalidFormat: 'Format invalid. Folosește SVG sau PNG cu fundal transparent.',
    builderFileTooLarge: 'Fișier prea mare. Maximum 200 KB.',
    builderCustomIcon: 'Pictogramă personalizată',
    builderSaveForReuse: 'Salvează în catalog pentru reutilizare',
    builderUseIcon: 'Folosește pictograma',
    builderIconHelp: 'SVG sau PNG, fundal transparent, recomandat 512×512 px, max. 200 KB',
    builderPreviewCompleteStep1: 'Completează datele din Pasul 1 pentru a vedea previzualizarea',
    builderPreviewClickToEdit: 'Apasă pe orice text pentru a-l edita',
    builderPreviewNoQuestions: 'Întrebările vor apărea aici la Pasul 3',
    builderPreviewGeneral: 'General',
    builderPreviewPersonalized: 'Personalizat',
    builderPreviewPulsoEspecifica: 'Puls specific',
    builderPreviewChangeIcon: 'Schimbă pictograma',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Colectiv',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'Matrice generală',
    builderPreviewMissingTranslation: '(fără traducere)',
    builderPreviewWriteAnswer: 'Scrie răspunsul tău aici...',
    builderPreviewNoObs: 'Neobservabil',
    builderPreviewNA: 'N/A',
    // Step nav labels
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Audiență',
    builderNavPreguntas: 'Întrebări',
    builderNavConfig: 'Setări',
    builderNavPublicar: 'Publică',
    builderNavGuardar: 'Salvează',
    // Step 1 title
    builderInfoTitle: 'Informații de bază',
    // Audience step
    builderSelectAll: 'Selectează tot',
    // Language names
    langEn: 'Engleză',
    langDe: 'Germană',
    langPt: 'Portugheză',
    langFr: 'Franceză',
    langNl: 'Neerlandeză',
    langRo: 'Română',
    // Translation placeholders
    builderTrlPlaceholderIn: 'în',
    builderTrlPlaceholderOpt: 'Opțiune',
    builderTrlNoText: 'Încă nu există text',
    // New keys added during refactor
    builderLinkedTo: 'Asociat cu',
    builderSelectedIcon: 'Selectat',
    builderHidePreview: 'Ascunde previzualizarea',
    builderShowPreview: 'Arată previzualizarea',
    builderPreviewMorePersons: 'mai multe persoane',
    builderPreviewOption1: 'Opțiunea 1',
    builderPreviewOption2: 'Opțiunea 2',
    builderPreviewViewIn: 'Vezi în:',
    builderFromOU: 'din',
    builderWillReceiveSurvey: 'va primi acest sondaj',
    builderPersonsCount: 'persoane',
    builderPersonsPlural: 'persoane',
    builderPersonSingular: 'persoană',
    builderInternalIdPlaceholder: 'Ex.: Fundamentale T1 2026',
    builderMeetingIdPlaceholder: 'Ex.: 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Opțiune',
    builderRemovePerson: 'Elimină',
    builderSaveTemplateMock: 'Salvat ca șablon ✓',
    builderPublishGlobalLabel: 'Global (excl. Europa)',
    builderTypeRating: 'Evaluare (1-4)',
    builderTypeMultiple: 'Alegere multiplă',
    builderTypeOpen: 'Întrebare deschisă',
    builderTypeBehaviors: 'Comportamente',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Sistem',
    // Monitor tab
    monitorTab: 'Monitorizare',
    // Trace tab
    traceTab: 'Trasabilitate',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'Sincronizarea nomenclatorului de personal',
    subtitle: 'De unde provin utilizatorii și unitățile organizaționale, catalogul de domenii corporative și starea fiecărei rulări.',
    ouCatalogSync: 'Sincronizare OU-uri',
    userCatalogSync: 'Sincronizare utilizatori',
    statusNeverRun: 'Niciodată executat',
    statusRunning: 'Se execută…',
    statusSuccess: 'Succes',
    statusSkipped: 'Omis',
    statusFailed: 'Eroare',
    lastRun: 'Ultima execuție',
    duration: 'Durată',
    triggerScheduled: 'Automat',
    triggerManual: 'Manual',
    created: 'Create',
    updated: 'Actualizate',
    unchanged: 'Neschimbate',
    skipReason: 'Motiv',
    errorMessage: 'Eroare',
    nextScheduled: 'Următoarea execuție automată',
    nextScheduledUnknown: 'Se calculează după prima execuție',
    padronTitle: 'Registru',
    padronTotal: 'Fișe în total',
    padronUnclaimed: 'Nerevendicate',
    padronLoading: 'Se numără…',
    padronError: 'Registrul nu a putut fi citit.',
    padronHint: 'O fișă nerevendicată aparține unei persoane care nu s-a conectat încă. Nu apare în listele de administrare.',
    identity: "Identitatea contoarelor",
    identityOk: "Se închide",
    identityBad: "NU se închide: {{suma}} vs {{recibidas}}",
    drift: "Abatere de numărare",
    duplicateEmail: "E-mailuri duplicate în sursă",
    ouSubidaARaiz: "Fișe mutate la unitatea lor rădăcină",
    ouHuerfanaResuelta: "Unități inexistente rezolvate după regiune",
    ouHuerfanaSinResolver: "Unități deteriorate NEREZOLVATE",
    managerLinks: "Manageri rezolvați",
    runNow: 'Execută acum',
    runningDisabled: 'Deja în execuție',
    viewHistory: 'Vezi istoricul',
    hideHistory: 'Ascunde istoricul',
    historyEmpty: 'Nu există încă execuții înregistrate.',
    historyLoading: 'Se încarcă istoricul…',
    historyError: 'Istoricul nu a putut fi încărcat.',
    colDate: 'Data',
    colTrigger: 'Declanșator',
    colStatus: 'Stare',
    colDuration: 'Durată',
    colDetail: 'Detaliu',
    triggerError: 'Jobul nu a putut fi executat.',
    triggerConflict: 'Jobul este deja în execuție — așteptați să se termine.',
    tabs: {
      users: 'Utilizatori',
      ous: 'Unități organizaționale',
      domains: 'Domenii (Excel)',
      sentinels: 'E-mailuri ignorate (SF)',
    },
    runsTitle: 'Rulări',
    noJobs: 'Nu există rulări înregistrate pentru această secțiune.',
    sfUserSync: 'Utilizatori (SuccessFactors)',
    sfOuSync: 'Unități organizaționale (SuccessFactors)',
    adDomainSweep: 'Scanarea domeniilor din director',
    cuentasBarridas: 'Conturi active scanate',
    dominiosObservados: 'Domenii observate',
    dominiosNoDeclarados: 'Observate, dar nedeclarate',
    dominiosDesaparecidos: 'Declarate, dar care nu se mai observă',
    dominiosDesactivados: 'Domenii dezactivate',
    sync: {
      title: 'Sursa de date',
      desc: 'De unde provine nomenclatorul de colaboratori.',
      users: 'Sursa utilizatorilor',
      adOnly: 'Doar Active Directory',
      adOnlyHint: 'Colaboratorii cu cont corporativ provin din AD. SuccessFactors continuă să ruleze, dar numai pentru colaboratorii fără e-mail corporativ: nu sunt în AD și altfel nu ar intra niciodată.',
      apiOnly: 'Doar SuccessFactors',
      apiOnlyHint: 'Tot nomenclatorul provine din SuccessFactors, inclusiv colaboratorii corporativi. Rularea din AD este omisă.',
      adThenApi: 'AD, apoi SuccessFactors',
      adThenApiHint: 'Rulează amândouă. SuccessFactors completează doar ce a lăsat gol AD; singura excepție este țara, care este scrisă întotdeauna de SuccessFactors.',
      ous: 'Unități organizaționale',
      ousDesc: 'De unde provine arborele unităților organizaționale.',
      ouSource: 'Sursa arborelui',
      ouAd: 'Active Directory',
      ouApi: 'SuccessFactors',
      sf: 'SuccessFactors',
      sfEnabled: 'Sincronizare activată',
      dryRun: 'Mod simulare',
      dryRunHint: 'Rularea numără tot și raportează rezultatele, dar NU scrie nicio modificare. Este modul recomandat pentru prima execuție.',
      sfOn: 'Activată',
      sfOff: 'Oprită',
      sfDryRun: 'Activată, în simulare',
      sfManagedInUsers: 'Se configurează în fila Utilizatori: aceleași comutatoare guvernează ambele rulări.',
      domains: 'Domenii corporative permise — încărcare prin Excel',
      domainsDesc: 'Se aplică DOAR încărcării în masă prin Excel pentru Europa și SUA. Dacă adăugați un domeniu, persoanele din fișier cu acel e-mail se vor autentifica prin SSO și nu se vor mai putea înregistra. Dacă eliminați unul, e-mailul lor este ignorat la încărcare și acele persoane vor trebui să îl declare pe al lor la înregistrare. Nu afectează sincronizarea cu Active Directory sau cu SuccessFactors.',
      domainsHint: 'Unul pe linie, sau separate prin virgule.',
      domainsCount: '{{n}} domenii',
      domainBadFormat: 'nu pare un domeniu (verificați spațiile, semnele @ sau căile)',
      domainDuplicate: 'duplicat: se va salva o singură dată',
      domainsRemoved: 'Se vor ELIMINA',
      domainsRemovedWarning: 'Oamenii lor nu se vor mai autentifica prin SSO și se vor putea înregistra cu parolă.',
      domainsAdded: 'Se vor ADĂUGA',
      domainsAddedWarning: 'Oamenii lor vor fi obligați să se autentifice prin SSO și nu se vor putea înregistra.',
      domainsReview: 'Verifică și salvează',
      domainsConfirm: 'Confirmă modificarea',
      domainsCancel: 'Anulează',
      domainsAllInvalid: 'Niciun domeniu valid: lista goală nu poate fi salvată.',
      domainsSaved: 'Catalogul de domenii a fost salvat.',
      saved: 'Configurația a fost salvată.',
      loadError: 'Nu s-a putut citi configurația surselor.',
      updatedBy: 'Ultima modificare de',
      errSession: 'Sesiunea a expirat. Autentificați-vă din nou și repetați modificarea.',
      errForbidden: 'Nu aveți permisiunea de a salva această configurație: este necesar rolul AdminGlobal.',
      errValidation: 'Configurația nu a trecut validarea: {{detalle}}',
      errValidationPlain: 'Configurația nu a trecut validarea de pe server.',
      errOther: 'Nu s-a putut salva (eroare {{status}}). Dacă se repetă, trebuie consultat jurnalul serviciului.',
      errNetwork: 'Nu s-a putut salva: nu a existat răspuns de la server. Verificați conexiunea și încercați din nou.',
      sentinels: 'E-mailuri ignorate din SuccessFactors',
      sentinelsDesc: 'Se aplică DOAR sincronizării cu SuccessFactors. Este textul pe care sursa îl pune în câmpul de e-mail când persoana NU are e-mail. Nu sunt adrese: se compară doar partea de dinaintea @, așa că „nomail” acoperă nomail@orice-domeniu. Dacă eliminați o intrare, acel text va fi salvat ca o adresă reală: cine îl aduce va conta drept corporativ, nu se va mai putea înregistra, iar rularea poate eșua din cauza e-mailului duplicat.',
      sentinelsHint: 'Unul pe linie. Puteți lipi adrese complete: se salvează doar partea de dinaintea @.',
      sentinelsCount: '{{n}} intrări',
      sentinelBadFormat: 'nu pare un nume de cutie poștală valid (verificați spațiile sau caracterele neobișnuite)',
      sentinelNormalized: 'se va salva ca „{{valor}}”, deci va acoperi acel nume pe ORICE domeniu',
      sentinelsRemovedWarning: 'Acel text va fi salvat din nou ca o adresă reală. Dacă două persoane îl au, rularea va eșua din cauza e-mailului duplicat.',
      sentinelsAddedWarning: 'Cine aduce acel text va fi considerat „fără e-mail” și va trebui să se înregistreze.',
      sentinelsSaved: 'Lista de e-mailuri ignorate a fost salvată.',
      sentinelsEmpty: 'Lista nu poate rămâne goală: fără nicio intrare, e-mailurile marcatoare ale sursei ar fi salvate ca adrese reale și rularea ar eșua.',
    },
  },
  monitor: {
    title: 'Monitor pipeline',
    subtitle: 'Audit de eligibilitate per întâlnire: reguli evaluate, participanți excluși și eșantionare aplicată.',
    refresh: 'Reîmprospătează',
    loading: 'Se încarcă evenimentele…',
    lastFetch: 'Actualizat',
    timeout: 'Timeout (10s) — MeetingService nu a răspuns.',
    unknownError: 'Eroare necunoscută',
    empty: 'Niciun eveniment de pipeline. Procesează sau simulează o întâlnire pentru a vedea înregistrări.',
    eligible: 'Eligibil',
    ineligible: 'Neeligibil',
    excluded: 'Exclus',
    sampled: 'Eșantionat',
    samplingApplied: 'Eșantionare aplicată',
    noParticipants: 'Niciun detaliu despre participanți.',
    statTotal: 'Întâlniri procesate',
    statEligible: 'Întâlniri eligibile',
    statAvgSampled: 'Medie eșantionată',
    statAvgSampledSub: 'per întâlnire eligibilă',
    statSampling: 'Eșantionare aplicată',
    statSamplingSub: 'întâlniri cu maxPax activ',
    colMeetingId: 'ID întâlnire',
    colDate: 'Dată',
    colDuration: 'Durată',
    colEvaluated: 'Evaluat',
    colEligible: 'Eligibil',
    colSampled: 'Eșantionat',
    colMaxPax: 'Eșantionare',
    colResult: 'Rezultat',
    colUserId: 'Utilizator',
    colOu: 'UO',
    colTimezone: 'Fus orar',
    colToday: 'Astăzi',
    colWeek: 'Săptămână',
    colInterval: 'Interval',
    colStatus: 'Stare',
    colReason: 'Motiv',
    colSample: 'Sondaj',
    instancesTitle: 'Sondaje alocate',
    instancesBtnTitle: 'Vezi sondajele pentru acest participant',
    instancesLoading: 'Se încarcă sondajele…',
    instancesEmpty: 'Nu s-au găsit instanțe de sondaj pentru acest participant în această întâlnire.',
    instancesSurvey: 'Sondaj',
    instancesStatus: 'Stare',
    instancesExpires: 'Expiră',
    instancesDownload: 'Descarcă JSON',
    instancesClose: 'Închide',
    sortAsc: 'Sortare crescătoare',
    sortDesc: 'Sortare descrescătoare',
    recalculate: 'Recalculează răspunsurile',
    recalculateTitle: 'Recalculează numărul de răspunsuri pentru toate sondajele',
    recalculateSuccess: 'Recalculare finalizată: {{count}} sondaj(e) actualizat(e).',
    recalculateError: 'Eroare la recalcularea răspunsurilor.',
    cacheTitle: 'Cache catalog UO-uri',
    cacheLoading: 'Se verifică memoria cache…',
    cacheError: 'Nu s-a putut obține starea memoriei cache pentru UO-uri.',
    cachePopulated: 'Populată',
    cacheNotPopulated: 'Nepopulată',
    cacheOuCount: 'UO-uri în cache',
    cacheLastSynced: 'Ultima sincronizare',
    cacheNeverSynced: 'Niciodată sincronizat',
  },
  trace: {
    title: 'Trasabilitatea pipeline-ului',
    subtitle: 'Parcursul complet al unei întâlniri, de la încheierea apelului până la trimiterea notificării.',
    filterModeLabel: 'Caută după',
    filterModeSubject: 'Numele întâlnirii',
    filterModeEmail: 'E-mail',
    filterPlaceholderSubject: 'Ex.: Daily de platformă',
    filterPlaceholderEmail: 'Ex.: nume.prenume@sigma.com',
    search: 'Caută',
    searching: 'Se caută…',
    clear: 'Șterge',
    initialHint: 'Alege un mod de căutare și scrie un termen pentru a vedea trasabilitatea.',
    invalidEmail: 'Introdu o adresă de e-mail validă.',
    requestError: 'Trasabilitatea nu a putut fi obținută. Încearcă din nou.',
    retry: 'Încearcă din nou',
    download: 'Descarcă trasabilitatea (JSON)',
    notFoundEmailNotRegistered: 'Acest e-mail nu este înregistrat ca utilizator. Verifică sincronizarea cu Azure AD.',
    notFoundUserWithoutMeetings: 'Utilizatorul există, dar nu a participat la nicio întâlnire înregistrată.',
    notFoundSubjectNoMatches: 'Nicio întâlnire nu corespunde acestui nume.',
    notFoundMeetingNotFound: 'Această întâlnire nu mai există.',
    notFoundUserDirectoryUnavailable: 'Directorul de utilizatori nu a putut fi consultat. Verifică dacă UserAdminService este disponibil.',
    matchesTitle: 'Mai multe întâlniri corespund — alege una',
    matchesSubject: 'Întâlnire',
    matchesOrganizer: 'Organizator',
    matchesStatus: 'Stare',
    matchesStarted: 'Început',
    matchesEnded: 'Sfârșit',
    meetingSummary: 'Întâlnire',
    meetingCorrelation: 'CorrelationId',
    meetingDuration: 'Durată',
    meetingStatus: 'Stare',
    warningsTitle: 'Avertismente',
    stagesTitle: 'Etapele pipeline-ului',
    stageColOrder: '#',
    stageColName: 'Etapă',
    stageColService: 'Serviciu',
    stageColTime: 'Oră',
    stageColOutcome: 'Rezultat',
    stageMeetingEnd: 'Sfârșitul întâlnirii',
    stageMeetingEligibility: 'Eligibilitatea întâlnirii',
    stageParticipantEligibility: 'Eligibilitatea participanților',
    stageSurveyCreation: 'Crearea sondajelor',
    stageNotification: 'Notificări',
    outcomeOk: 'OK',
    outcomeError: 'Eroare',
    outcomeNotEligible: 'Neeligibil',
    outcomeNoData: 'Fără date',
    logsTitle: 'Jurnal brut corelat',
    logsSubtitle: 'Intrări din MeetingService, SurveyService, AnalyticsService și Bot. NotificationService nu păstrează jurnal brut.',
    logsEmpty: 'Nicio intrare de jurnal pentru această întâlnire. TTL-ul pentru app_logs este de 24 de ore.',
    logsFilterAll: 'Toate',
    logsFilterWarning: 'Warning și peste',
    logsFilterError: 'Doar erori',
    logsColTime: 'Oră',
    logsColService: 'Serviciu',
    logsColLevel: 'Nivel',
    logsColMessage: 'Mesaj',
  },
  system: {
    title: 'Diagnosticare sistem',
    subtitle: 'Starea în timp real a tuturor microserviciilor și workerilor backend.',
    refreshAll: 'Reîmprospătează tot',
    refresh: 'Reîmprospătează',
    lastChecked: 'Ultima verificare',
    checking: 'Se verifică…',
    never: 'Niciodată',
    statusHealthy: 'Sănătos',
    statusDegraded: 'Degradat',
    statusError: 'Eroare de conexiune',
    showDetails: 'Arată verificările',
    hideDetails: 'Ascunde verificările',
    legendTitle: 'Glosar de stări',
    legendHealthyDesc: 'Toate verificările interne ale serviciului au răspuns corect.',
    legendDegradedDesc: 'Serviciul răspunde, dar MongoDB, Redis sau Service Bus a raportat o eroare.',
    legendErrorDesc: 'Serviciul nu a putut fi contactat de la frontend (timeout, CORS sau serviciu oprit).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Abonamente',
    activeMessages: 'Mesaje active',
    deadLetterMessages: 'Dead Letter',
    environment: 'Mediu',
    version: 'Versiune',
    workers: 'Workeri',
    workersDesc: 'Stare dedusă din statisticile de abonamente Service Bus.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Nicio statistică de abonament disponibilă.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Eroare',
  },
  analytics: {
    title: 'Panou executiv',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Distorsiuni',
    omissions: 'Omiteri',
    personal: 'Personal',
    score: 'Scor',
    responses: 'Răspunsuri',
    participants: 'Participanți',
    period: 'Perioadă',
    ou: 'Unitate organizațională',
    noData: 'Date insuficiente',
    completionRate: 'Rata de finalizare',
    avgByCategory: 'Medie pe categorie',
    organization: 'Organizație',
    fundamentalsRadar: 'Radar fundamentale',
    heatmapOuFund: 'Hartă termică — Scor pe unitate organizațională și fundamental',
    moduleInDev: 'Modul în dezvoltare',
    executiveSubtitle: 'vizualizare executivă',
    exec: {
      periodAll: 'Tot istoricul',
    },
    tabs: {
      summary: 'Rezumat',
      fundamentals: 'Fundamentale',
      heatmap: 'Hartă termică',
      orgNetwork: 'Rețea organizațională',
      generational: 'Generațional',
    },
    noScopeTitle: 'Nicio unitate organizațională atribuită',
    noScopeDesc: 'Contul dvs. nu are unități organizaționale atribuite, deci nu există rapoarte de afișat. Solicitați administratorului central să vă configureze domeniul.',
    filterBar: {
      allOrg: 'Toată organizația',
      allMyScope: 'Tot domeniul meu',
      allBU: 'Toate BU-urile',
      allDept: 'Toate departamentele',
      allDimensions: 'Toate comportamentele',
      clearFilters: 'Șterge filtrele',
      dateFrom: 'De la',
      dateTo: 'Până la',
    },
    dimensionFilter: {
      partialScope: 'Filtrat după „{{dimension}}”. Rata de răspuns, evaluatorii, chestionarele pe zi și omisiunile nu sunt defalcate pe comportament: acoperă întregul domeniu.',
      notApplicable: 'Acest bloc nu este defalcat pe comportament: se afișează fără filtrul „{{dimension}}”.',
    },
    kpi: {
      evaluatedPeople_one: '{{count}} persoană evaluată',
      evaluatedPeople_other: '{{count}} persoane evaluate',
      responseRateSub: 'din sondajele deja închise',
      evaluations: 'Evaluări',
      avgScore: 'Scor mediu',
      responseRate: 'Rata de răspuns',
      avgPerDay: 'Medie / zi',
      evaluators: 'Evaluatori',
      scale: 'scală 1–4',
      noObservables: 'neobservabil',
      perDay: 'sondaje pe zi',
      activeParticipants: 'participanți activi',
      ofTotal: 'total',
    },
    summary: {
      evaluationsCount_one: '{{count}} evaluare',
      evaluationsCount_other: '{{count}} evaluări',
      behaviorPositioningDesc: 'Clasament pe comportament; fundamentele fără comportamente configurate se afișează integral',
      behaviorColumn: 'Comportament',
      distribution: 'Distribuție',
      omittedSurveys: 'Omise',
      topBehaviors: 'Top obiceiuri zilnice',
      topDailyHabitsSubtitle: 'Obiceiurile cu cel mai mare impact cultural',
      oppSubtitle: 'Obiceiurile cu cel mai mult loc de îmbunătățire',
      opportunities: 'Zone de oportunitate',
      omissionsByUnit: 'Omiteri pe unitate',
      omissionsSubtitle: 'Rata de omitere pe UO și BU — sortată descrescător · Apasă pe o UO pentru a vedea BU-urile sale',
      downloadExcel: 'Descarcă Excel',
      omitType: 'Tip',
      omitPeople: 'Persoane',
      omitRate: 'Rata de omitere',
      noOmissions: 'Nicio omitere semnificativă',
      percentileDistribution: 'Distribuție pe percentile',
      percentileSubtitle: 'Procentul populației în fiecare interval de scor',
      personsEvaluated: 'persoane evaluate',
      excellent: 'Excelent',
      good: 'Bun',
      developing: 'În dezvoltare',
      attention: 'Necesită atenție',
      fundPositioning: 'Poziționarea fundamentalelor',
      fundPositioningDesc: 'Clasament, scor cel mai mare/mic și rata neobservabil pe fundamental',
      highestScore: 'Cel mai mare scor',
      lowestScore: 'Cel mai mic scor',
      mostNoObs: 'Cel mai mult neobservabil',
      scoreByOU: 'Scor pe unitate organizațională',
      scoreByOUSubtitle: 'Apasă pe o UO pentru a vedea defalcarea pe BU și Departament',
      person: 'persoană',
      persons: 'persoane',
    },
    fundamentals: {
      behaviorSubtitle: 'Fiecare fundament se împarte în comportamentele sale; extinde unul pentru a-i vedea daily habits',
      noObsCount_one: '{{count}} sondaj nu l-a evaluat',
      noObsCount_other: '{{count}} sondaje nu l-au evaluat',
      dailyHabits: 'Daily habits',
      title: 'Scor pe fundamental',
      subtitle: 'Extinde fiecare fundamental pentru a vedea obiceiurile sale zilnice și defalcarea pe UO',
      evalLabel: 'eval.',
      confPreliminary: 'Date preliminare',
      confBasedOn: 'Bazat pe {{n}} evaluări',
    },
    heatmap: {
      behaviorSubtitle: 'Scor pe unitate organizațională și comportament; atinge orice rând pentru a explora subunitățile',
      directlyAssigned: 'Alocați la {{ou}}',
      hideEmpty_one: 'Ascunde {{count}} unitate fără date',
      hideEmpty_other: 'Ascunde {{count}} unități fără date',
      personCount_one: '{{count}} persoană',
      personCount_other: '{{count}} persoane',
      title: 'Hartă termică culturală',
      subtitle: 'Apasă pe orice rând pentru a explora sub-unitățile sale',
      unit: 'Unitate',
      unitOU: 'Unitate organizațională',
      unitBU: 'Unitate de afaceri',
      unitDept: 'Departament',
      unitPerson: 'Lider',
      allOrg: 'Toată organizația',
      hint: 'Apasă pe orice rând pentru a explora nivelul următor →',
      person: 'persoană',
      persons: 'persoane',
      legendCritical: 'Critic',
      legendLow: 'Scăzut',
      legendMedium: 'Mediu',
      legendGood: 'Bun',
      legendExcellent: 'Excelent',
      noOu: 'Fără OU',
    },
    ona: {
      directlyAssigned: 'Alocați direct',
      collaboratorsCount_one: '{{count}} colaborator',
      collaboratorsCount_other: '{{count}} colaboratori',
      typeBu: 'BU',
      typeDept: 'Dept.',
      typePerson: 'Persoană',
      title: 'Rețea organizațională (ONA)',
      subtitle: 'Arbore interactiv al unităților organizaționale (UO)',
      treeHint: 'Extinde fiecare nod pentru a naviga nivelurile de UO ale organizației.',
      omissions: 'Omiteri',
      totalPeople: 'Persoane',
      avgScore: 'Scor mediu',
      totalEvals: 'Total evaluări',
      collaboratorsKpi: 'Colaboratori',
      highestOmission: 'Cea mai mare omitere',
      omissionsRanking: 'Clasament omiteri',
      maturityCulture: 'Maturitate culturală',
      maturityLegend: 'Legendă maturitate',
      maturityInitial: 'Inițial',
      maturityGrowing: 'În creștere',
      maturityConsolidated: 'Consolidat',
      maturityRoleModel: 'Model de urmat',
      evalsLabel: 'evaluări',
      noEvals: 'Nicio evaluare',
      collaboratorsLabel: 'colaboratori',
      omissionLabel: 'omitere',
      evalsShort: 'eval.',
      omittedCount_one: '{{count}} omisă',
      omittedCount_few: '{{count}} omise',
      omittedCount_other: '{{count}} de omise',
    },
    gen: {
      personasCount_one: '{{count}} persoană',
      personasCount_other: '{{count}} persoane',
      panorama: 'Prezentare generală',
      ranking: 'Clasament',
      brechas: 'Diferențe',
      avgAge: 'Vârstă medie',
      title: 'Analiză generațională',
      subtitle: 'Distribuție culturală și maturitate pe cohortă · {{n}} persoane mapate',
      noRepresentation: 'Nicio reprezentare',
      scoreLabel: 'Scor',
      omissionLabel: 'Omitere',
      personas: 'persoane',
      age: 'Vârstă',
      all: 'Toate',
      noData: 'Nu există date pentru acest filtru',
      fundamental: 'Fundamental',
      gapCol: 'Δ Diferență',
      brechaNote: 'Cea mai mare diferență: {{fund}} · Δ {{delta}} pct între generații',
      brechaSource: 'Diferență față de media generală a fundamentalului în organizație',
      responseCount: '{{n}} răspunsuri',
    },
  },
  userConfig: {
    fabTitle: 'Configurează profilul utilizatorului',
    title: 'Profil utilizator (demo)',
    subtitle: 'Mod de testare — simulează datele care vor proveni din Teams SSO la integrarea cu backend-ul',
    nombre: 'Nume',
    correo: 'E-mail',
    ou: 'UO (Unitate organizațională)',
    do_: 'DO (Diviziune)',
    bu: 'BU (Unitate de afaceri)',
    departamento: 'Departament',
    puesto: 'Funcție',
    numeronomina: 'Număr de angajat',
    role: 'Rol',
    roleDetected: 'Rol detectat',
    roleNotFound: 'E-mailul nu a fost găsit printre utilizatori — se va folosi rolul Angajat',
    save: 'Salvează profilul',
    namePlaceholder: 'Ex.: Ana García',
    emailPlaceholder: 'Ex.: agarcia@sigma.com',
    ouPlaceholder: 'Ex.: Tehnologie',
    doPlaceholder: 'Ex.: Diviziunea Tehnologie',
    buPlaceholder: 'Ex.: Mexic',
    deptPlaceholder: 'Ex.: Dezvoltare software',
    puestoPlaceholder: 'Ex.: Inginer software senior',
    nominaPlaceholder: 'Ex.: 123456',
    fechaNacimiento: 'Data nașterii',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'A apărut o eroare neașteptată',
    unauthorized: 'Nu ai permisiunea pentru această acțiune',
    notFound: 'Resursă negăsită',
    network: 'Eroare de conexiune. Verifică-ți rețeaua.',
  },
  fundamentals: {
    title: 'Fundamentale',
    subtitle: 'Comportamentele pe care le măsurăm la Sigma. Deschide unul pentru a vedea obiceiurile zilnice.',
    habitsFor: 'Obiceiuri zilnice',
    otherHabits: 'Alte obiceiuri',
    openHabits: 'Vezi obiceiurile zilnice pentru {{name}}',
    openMicrosite: 'Deschide microsite-ul pentru {{name}}',
  },
};

export default ro;
